














































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import gtOssUpload from "@root/components/gt-oss-upload/index.vue";
@Component({ components: { gtOssUpload } })
export default class chooseMedia extends Vue {
  private acceptType =
    "image/webp,image/bmp,image/gif,image/jpeg,image/jpg,image/png,video/*";
  ruleForm: any = {};
  @Prop({ default: () => {} })
  mediaData: any;
  @Prop({ default: true })
  hasChonfirmBtn: boolean;
  @Prop({ default: "spu" }) activeTab;
  @Prop({ default: false }) readonly;
  max = 8;
  num(mediaLink) {
    let link = this.ruleForm[mediaLink] || [];
    return `${link.length} / ${this.max}`;
  }
  @Watch("mediaData")
  onMediaDataChange(val) {
    this.ruleForm = val;
  }
  @Watch("activeTab")
  watchActiveTab(val) {
    if (this.activeName !== val) {
      this.activeName = val;
    }
  }
  activeName = "spu";
  mounted() {
    this.ruleForm = this.mediaData;
  }
  onsuccess([fileUrl, fileList], link) {
    this.mediaChange(fileList, link);
  }
  onRemove([index, fileList], link) {
    this.mediaChange(fileList, link);
  }
  mediaChange(fileList, link) {
    this.ruleForm[link] = fileList.map(item => item.url);
    const parama = {
      mediaLink: this.ruleForm.mediaLink.join(","),
      mobileMediaLink: this.ruleForm.mobileMediaLink.join(",")
    };
    this.$emit("confirm", parama);
  }
  dragEnd([fileList], link) {
    this.mediaChange(fileList, link);
  }
  handleSubmit() {
    const parama = {
      mediaLink: this.ruleForm.mediaLink.join(","),
      mobileMediaLink: this.ruleForm.mobileMediaLink.join(",")
    };
    this.$emit("confirm", parama);
  }
}
